const achievementMenuItems = [
  {
    id: "monthly-progress-reports",
    label: "Monthly Progress Reports",
    path: "/achievements/monthly-progress-reports",
  },
  {
    id: "overall-achievements",
    label: "Overall Achievements",
    path: "/achievements/overall-achievements",
  },
  {
    id: "population-wise-cumulative-disbursement",
    label: "Population wise Cumulative Disbursement",
    path: "/achievements/population-wise-cumulative-disbursement",
  },
  {
    id: "state-wise-achievement",
    label: "State Wise Achievement",
    path: "/achievements/state-wise-achievement",
  },
  {
    id: "year-wise-achievement",
    label: "Year Wise Achievement",
    path: "/achievements/year-wise-achievement",
  },
  {
    id: "year-wise-disbursement-details",
    label: "Year Wise Disbursement Details",
    path: "/achievements/year-wise-disbursement-details",
  },
];

export default achievementMenuItems;
